<template>
  <tr :class="computedClass" :style="computedStyle"
    @click="$emit('click', $event)">
    <slot></slot>
  </tr>
</template>

<script>
export default {
  props: ["header", "selected", "disabled", "background", "small"],

  computed: {
    computedClass() {
      const tableRow = this.small ? "table-row table-row-small" : "table-row";

      return this.selected ? `${tableRow} selected` : tableRow;
    },
    computedStyle() {
      const background = this.background
        ? `background-color: ${this.background};`
        : "";

      return `${background} opacity: ${this.disabled ? "0.5" : "1"}`;
    },
  },
};
</script>

<style scoped>
.table-row {
  height: 38px;
  font-size: 0.75rem;
}

.table-row-small {
  height: 30px;
  font-size: 0.7rem;
}

.table-row td {
  border-bottom: 1px solid var(--s-box-line-border-color);
}

.table-row:hover {
  background-color: var(--s-box-line-border-color) !important;
}

.selected {
  background-color: var(--s-box-line-border-color) !important;
}
</style>